import { ToggleView } from "../views/toggle-view";
import { InvalidInputMessage } from "./invalid-input";
import { forwardRef, useImperativeHandle, useRef ,useEffect ,useState} from "react";

export const FormInput = ({
  dataModel,
  name,
  label,
  hint,
  type,
  defaultValue,
  required,
  readOnly,
  disabled,
  autoComplete,
  onChange,
  errorsModel,
  showLabel = false,
  className = ""
}) => {
  const hintId = `${name}Hint`;
  const model = dataModel || {};
  const value = model[name] ?? defaultValue ?? "";
  const errorMessage = errorsModel && errorsModel[name];
  const ac = autoComplete ?? "on";
  const [focus, setFocus] = useState(false);

  return (
    <div className="mb-3">
      {showLabel && (
        <label
          htmlFor={name}
          className="block mb-1 text-white text-sm"
        >
          {label || name}
          {required ? " *" : ""}
        </label>
      )}

      <div
        className={[
          "w-full h-[50px] flex items-center px-4",
          "rounded-[16px] bg-background-secondary",
          "ring-1 ring-[#34353F]",
          errorMessage ? "ring-chilli" : "",
          focus ? " outline-none ring-2 ring-white " : "  ",
          className
        ].join(" ")}
      >
        <input
          required={required}
          readOnly={readOnly}
          disabled={disabled}
          autoComplete={ac}
          type={type || "text"}
          name={name}
          id={name}
          style={{
            MozAppearance: "textfield",
          }}
          aria-describedby={hintId}
          value={value}
          onClick={(e) => e.currentTarget.select()} 
          onFocus={(e) => { e.currentTarget.select(); setFocus(true); }} 
          onWheel={(e) => e.currentTarget.blur()}
          onBlur={() => setFocus(false)}
          onChange={onChange}
          placeholder={showLabel ? undefined : (label || name)}
          className="w-full bg-transparent outline-none text-white placeholder:text-white/50 font-body-primary text-base"
        />
      </div>

      <InvalidInputMessage errorMessage={errorMessage} />
      <ToggleView show={!!hint}>
        <div id={hintId} className="mt-1 text-xs text-white">
          {hint}
        </div>
      </ToggleView>
    </div>
  );
};
